import { component } from 'picoapp';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default component((node, ctx) => {
  const isDesktop = ctx.getState().isDesktop;
  const cartCount = node.querySelector('.js-cart-count');
  const cartToggles = node.querySelectorAll('.js-cart-drawer-toggle');
  const announcementBar = document.querySelector('.js-announcement-bar');
  const announcementBarZindex = window.getComputedStyle(announcementBar).getPropertyValue('z-index');

  let animation;

  for (let i = 0; i < cartToggles.length; i++) {
    cartToggles[i].addEventListener('click', e => {
      e.preventDefault();

      ctx.emit('cart:toggle', state => {
        return {
          cartOpen: !state.cartOpen
        };
      });
    });
  }

  ctx.on('cart:updated', state => {
    cartCount.innerHTML = state.cart.item_count;
  });

  cartCount.innerHTML = ctx.getState().cart.item_count;

  const pinHeader = () => {
    gsap.set('.js-announcement-bar', { zIndex: 100 });
    gsap.set('.js-navigation', { top: '100%' });
    gsap.to('.js-header', { y: -100, borderBottomColor: '#e5dfcd' });
    gsap.to('.js-header-logo', { scale: 0.6 });
    gsap.to('.c-header__navigation > *', { y: 25 });
    gsap.to('.c-header__account-links > *', { y: 25 });
  };

  const unpinHeader = () => {
    gsap.to('.js-header', { y: 0, borderBottomColor: 'rgba(0,0,0,0)' });
    gsap.set('.js-navigation', { top: '100%' });
    gsap.to('.js-header-logo', { scale: 1 });
    gsap.to('.c-header__navigation > *', { y: 0 });
    gsap.to('.c-header__account-links > *', { y: 0 });
    gsap.set('.js-announcement-bar', { zIndex: announcementBarZindex });

  };

  const init = () => {
    if (isDesktop.matches) {
      animation = ScrollTrigger.create({
        trigger: '#root',
        start: 'top -80px',
        endTrigger: '.js-footer',
        end: 'top 50%',
        onEnter: () => pinHeader(),
        onEnterBack: () => pinHeader(),
        onLeaveBack: () => unpinHeader(),
        onLeave: () => unpinHeader(),
      });
    } else {
      animation && animation.kill();
    }

    isDesktop.addEventListener('change', init);
  };

  init();

});
